module.exports = __webpack_public_path__ + "static/media/skeleton.e451bca4.png";